import { useEffect, useState } from 'react';
import { Info } from 'lucide-react';
import { useReducedMotion, animate } from 'framer-motion';

export default function KpiCard({ title, value = 0, subtitle, tooltip, link }) {
  const [display, setDisplay] = useState(0);
  const shouldReduce = useReducedMotion();

  useEffect(() => {
    if (shouldReduce) {
      setDisplay(value);
      return;
    }
    const controls = animate(0, value, {
      duration: 0.6,
      onUpdate: (v) => setDisplay(Number(v.toFixed(0))),
    });
    return () => controls.stop();
  }, [value, shouldReduce]);

  return (
    <div className="bg-header text-default border border-border rounded-lg p-4 flex flex-col space-y-2">
      <div className="flex items-start justify-between">
        <div>
          <div className="text-sm font-medium">{title}</div>
        </div>
        {tooltip && (
          <div className="group relative">
            <Info className="w-4 h-4 text-muted" />
            <div className="absolute left-1/2 -translate-x-1/2 mt-2 hidden group-hover:block bg-app text-default text-xs rounded shadow-lg p-2 z-10 w-48">
              {tooltip}
            </div>
          </div>
        )}
      </div>
      <div className="text-3xl font-semibold" aria-live="polite">
        {display}
      </div>
      {subtitle && <div className="text-xs text-muted">{subtitle}</div>}
      {link && (
        <a
          href={link}
          className="text-sm text-primary hover:text-primary-hover focus:outline-none focus:ring-2 focus:ring-focus rounded"
        >
          View details
        </a>
      )}
    </div>
  );
}